<template>
  <div class="login-bg">
    <div
      class="login-cont container"
      style="height: 80vh;"
    >
      <div class="d-flex justify-content-center h-100">
        <div class="col-12 px-0 d-flex flex-column my-auto">
          <!-- <div class="card border-0 mb-0 auth-card bg-transparent"> -->
          <div
            class="card-body px-2 d-flex mx-0 col-12 mx-auto"
            style="background: rgba(26, 10, 12, 0.72);border-radius: 16px;box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);backdrop-filter: blur(12px);-webkit-backdrop-filter: blur(12px);border: 1px solid rgba(245, 197, 24, 0.35);"
          >
            <div class="col-12">
              <div class="text-center mb-4">
                <div
                  class="error text-center py-2"
                  v-if="error"
                >
                  <span class="mx-auto">
                    {{ $t('auth.fail_message') }}
                  </span>
                </div>
              </div>
              <form role="form">
                <small class="text-dark">{{ errors.name }}</small>
                <div class="form-group mb-3">
                  <label style="color: #F5C518; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.username')
                  }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <input
                    class="form-control pl-2 px-4"
                    style="background: linear-gradient(180deg, #fff8e7 0%, #ffffff 100%) !important; color: #1a1212; box-shadow: none; border-radius: 8px; border: 1px solid rgba(245, 197, 24, 0.45); font-size: 1.2rem;"
                    type="text"
                    v-model="name"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <!-- </div> -->
                </div>

                <div class="form-group mb-3 pt-3">
                  <small class="text-dark">{{ errors.phone }}</small>
                  <label style="color: #F5C518; font-weight: 550; letter-spacing: 0.5px;">{{ $t('setting.phone')
                  }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <input
                    class="form-control pl-2 px-4"
                    style="background: linear-gradient(180deg, #fff8e7 0%, #ffffff 100%) !important; color: #1a1212; box-shadow: none; border-radius: 8px; border: 1px solid rgba(245, 197, 24, 0.45); font-size: 1.2rem;"
                    type="text"
                    v-model="phone"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <!-- </div> -->
                </div>
                <small class="text-dark">{{ errors.password }}</small>
                <div class="form-group pt-3">
                  <label style="color: #F5C518; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.password')
                  }}</label>
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4"
                      style="background: linear-gradient(180deg, #fff8e7 0%, #ffffff 100%) !important; color: #1a1212; box-shadow: none; border-radius: 8px; border: 1px solid rgba(245, 197, 24, 0.45); font-size: 1.2rem;"
                      type="password"
                      ref="password"
                      v-model="password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password"
                      style="color: #F5C518;"
                      v-if="isShowPassword"
                      @click="showablePassword('password')"
                    ></i>
                    <i
                      v-if="!isShowPassword"
                      class="fas fa-eye-slash showable-password"
                      style="color: #F5C518;"
                      @click="showablePassword('password')"
                    ></i>
                  </div>
                </div>
                <small class="text-dark">{{ errors.confirm_password }}</small>
                <div class="form-group pt-3">
                  <label style="color: #F5C518; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.confirm_password')
                  }}</label>
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4"
                      style="background: linear-gradient(180deg, #fff8e7 0%, #ffffff 100%) !important; color: #1a1212; box-shadow: none; border-radius: 8px; border: 1px solid rgba(245, 197, 24, 0.45); font-size: 1.2rem;"
                      type="password"
                      ref="confirm_password"
                      v-model="confirm_password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password"
                      style="color: #F5C518;"
                      v-if="isShowConfirmPassword"
                      @click="showablePassword('confirm_password')"
                    ></i>
                    <i
                      v-if="!isShowConfirmPassword"
                      class="fas fa-eye-slash showable-password"
                      style="color: #F5C518;"
                      @click="showablePassword('confirm_password')"
                    ></i>
                  </div>
                  <!-- </div> -->
                </div>
                <div class="text-center mt-4">
                  <button
                    type="button"
                    class="btn my-4"
                    style="background: linear-gradient(135deg, #9B1218 0%, #D71921 55%, #E83138 100%); color: #fff; border-radius: 20px; width: 14rem; box-shadow: 0 4px 14px rgba(215, 25, 33, 0.4); border: 1px solid rgba(245, 197, 24, 0.4); font-weight: 600;"
                    @click="loginWithPhone()"
                  >
                    <div v-if="!isSignin">
                      {{ $t('auth.sign_up') }}
                    </div>

                    <Loading
                      color="#ffffff"
                      v-if="isSignin"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
                <!-- <div class="col-12 d-flex my-1">
                      <div class="col-5 p-0 my-auto divider-line"></div>
                      <div class="my-auto divider-text px-3">OR</div>
                      <div class="col-5 p-0 my-auto divider-line"></div>
                    </div>
                    <div class="text-center mb-3">
                      <button
                        type="button"
                        class="btn my-4"
                        style="background: #dc2626; color: white; border-radius: 20px; width: 10rem; box-shadow: none;"
                        @click="$router.push('/auth/login')"
                      >
                        <div>
                          {{$t('auth.login')}}
                        </div>
                      </button>
                    </div> -->
                <!-- <div class="d-flex justify-content-center">
                      <span style="color: #ffffff; text-decoration: underline;" @click="$router.push('/auth/not-auth-verify')">Forgot Password?</span>
                    </div> -->
              </form>

              <div class="auth-contact-wrap">
                <p class="auth-contact__hint">
                  {{ $store.state.language === 'en' ? 'Need help?' : 'အကူအညီလိုပါသလား' }}
                </p>
                <div class="row auth-contact-row mx-0">
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile"
                      :href="loginViberHref"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--viber">
                        <i class="fab fa-viber"></i>
                      </span>
                      <span class="auth-contact__title">Viber</span>
                    </a>
                  </div>
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile auth-contact--telegram"
                      :href="telegramLink(loginTelegram)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--telegram">
                        <i class="fab fa-telegram-plane"></i>
                      </span>
                      <span class="auth-contact__title">{{ loginTelegramLabel }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <div class="row mt-3">
            <div class="col-4">
              <div
                class="modal fade"
                id="forgetPassword"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal- modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-body p-5">
                      <b>
                        Please direct contact to customer service -
                        <span class="text-dark">09756477723</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions, mapMutations } from 'vuex';
import { viberLink, telegramLink } from '@/utils/contactLinks';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      phone: null,
      password: null,
      confirm_password: null,
      error: false,
      errors: {},
      isSignin: false,
      isShowPassword: false,
      isShowConfirmPassword: false,
      defaultTelegram: 'https://t.me/buffaloboss_bot',
      defaultViber: 'https://msng.link/o?959767112456=vi',
    };
  },
  computed: {
    loginTelegram() {
      return this.$store.state.contactTelegram || this.defaultTelegram;
    },
    loginViberHref() {
      if (this.$store.state.contactInfo) {
        return viberLink(this.$store.state.contactInfo);
      }
      return this.defaultViber;
    },
    loginTelegramLabel() {
      const value = this.loginTelegram;
      if (String(value).startsWith('@')) {
        return value;
      }
      if (String(value).includes('t.me/')) {
        const handle = String(value).split('t.me/').pop().split(/[?#]/)[0];
        return handle ? `@${handle}` : 'Telegram';
      }
      return `@${value}`;
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    ...mapMutations(['setContactInfo', 'setContactTelegram']),
    telegramLink,
    showablePassword(ref) {
      if (ref === 'password') {
        if (this.isShowPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowPassword = !this.isShowPassword;
      } else {
        if (this.isShowConfirmPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowConfirmPassword = !this.isShowConfirmPassword
      }
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      console.log('1')
      if (!this.name) {
        this.errors.name =
          this.$store.state.language === 'en'
            ? 'Required User Name'
            : 'User name လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.phone) {
        this.errors.phone =
          this.$store.state.language === 'en'
            ? 'Required Phone'
            : 'Phone လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password =
          this.$store.state.language === 'en'
            ? 'Required Password'
            : 'Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.confirm_password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Required Confirm Password'
            : 'Confirm Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (this.confirm_password !== this.password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Password not match!'
            : 'Password not match!';
        this.isSignin = false;
        return false;
      }
      console.log('2')
      try {
        const res = await this.axios.post(
          '/auth/register',
          {
            user_name: this.name,
            phone: this.phone,
            password: this.password,
            confirmPassword: this.confirm_password,
            roles: 'normal',
            referralCode: localStorage.getItem('referralCode'),
            // code: localStorage.getItem('fcm'),
          },
        );
        localStorage.setItem('username', this.phone);
        localStorage.setItem('password', this.password);
        localStorage.setItem('token', res.data.token);


        await this.fetchUser();
        this.$router.push('/auth/login');

        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success!'
            : 'Success!'
        );
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
    async fetchWebsiteContact() {
      try {
        const res = await this.axios.get('/website-infos');
        const info = res.data.data[0];
        if (!info) return;
        this.setContactInfo(info.contact_info);
        this.setContactTelegram(
          info.telegram_info
            || info.contact_telegram
            || info.telegram
            || info.telegram_link
            || null
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    this.fetchWebsiteContact();
    if (this.$route.query.code) {
      localStorage.setItem('referralCode', this.$route.query.code);
    }
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal')
      this.$router.push('/home');
    const userName = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.login-bg {
  min-height: 100vh;
  width: 100%;
  background-image: url("https://storage.googleapis.com/spacetech2/buffalobossmm/login.avif");
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  background-color: #1A0A0C;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-cont {
  padding-top: 3rem;
}

.divider-line {
  border-top: 1px solid rgba(255, 255, 255, 0.6);
  height: 0;
}

.divider-text {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: #fff;
  border: 1px solid rgba(245, 197, 24, 0.45);
  border-radius: 8px;
  padding: 0px 15px;
  background: rgba(215, 25, 33, 0.35);
  /* font-weight: bold; */
}

.auth-card {
  background: #eeecec;
  /* color: black */
}

.auth-contact-wrap {
  margin-top: 1.25rem;
  padding-top: 0.25rem;
}

.auth-contact__hint {
  margin: 0 0 0.65rem;
  text-align: center;
  color: rgba(245, 197, 24, 0.75);
  font-size: 0.78rem;
  font-weight: 500;
}

.auth-contact-row {
  width: 100%;
}

.auth-contact-col {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.auth-contact {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 4.5rem;
  padding: 0.65rem 0.35rem;
  border-radius: 12px;
  border: 1px solid rgba(245, 197, 24, 0.35);
  background: rgba(255, 255, 255, 0.06);
  text-decoration: none;
  text-align: center;
  flex-direction: column;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.auth-contact:active {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(245, 197, 24, 0.55);
  text-decoration: none;
}

.auth-contact__icon {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.25rem;
}

.auth-contact__icon--viber {
  background: #7360f2;
  color: #ffffff;
}

.auth-contact__icon--telegram {
  background: #229ed9;
  color: #ffffff;
}

.auth-contact__title {
  color: #ffffff;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
  word-break: break-word;
}
</style>
